import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/development-financing/page.tsx")